import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import {ButtonState} from '../enums/ButtonState';
import {RequestStatus} from '../enums/RequestStatus';

/**
 * @param {ReduxRequestOptions} options
 */
export function validateOptions(options) {
  if (!isString(options.prefix)) {
    throw new Error('ReduxRequest missing required prefix');
  }
  if (!isFunction(options.getState)) {
    throw new Error('ReduxRequest missing required getState');
  }
  if (!isObject(options.logger)) {
    throw new Error('ReduxRequest missing required logger');
  }
  if (!isObject(options.requestFactory)) {
    throw new Error('ReduxRequest missing required requestFactory');
  }
  if (!isFunction(options.buildRequest)) {
    throw new Error('ReduxRequest missing required buildRequest');
  }
  if (!isFunction(options.getResponseStatus)) {
    throw new Error('ReduxRequest missing required getResponseStatus');
  }
}

/**
 * @param {AjaxResponse} ajaxResponse
 * @return {RequestStatus}
 */
export function getListResultResponseStatus(ajaxResponse) {
  if (ajaxResponse && ajaxResponse.responseType === 'json') {
    if (isObject(ajaxResponse.response)) {
      if (isArray(ajaxResponse.response.list)) {
        return ajaxResponse.response.list.length > 0 ? RequestStatus.SUCCESS : RequestStatus.NO_RESULTS;
      }
    }
  }

  // Fallback
  return RequestStatus.NO_RESULTS;
}

/**
 * @param {AjaxResponse} ajaxResponse
 * @return {RequestStatus}
 */
export function getSuccessOnlyResponseStatus(ajaxResponse) {
  return RequestStatus.SUCCESS;
}

/**
 *
 * @param {ReduxRequestState} requestState
 * @return {ButtonState}
 */
export function requestToButtonState(requestState) {
  switch (requestState.status) {
    case RequestStatus.IS_FETCHING:
      return ButtonState.WORKING;

    case RequestStatus.SUCCESS:
    case RequestStatus.NO_RESULTS:
      return ButtonState.SUCCESS;

    case RequestStatus.ERROR:
      return ButtonState.ERROR;

    case RequestStatus.PENDING:
    default:
      return ButtonState.START;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-request/utils.js